export default "__VITE_ASSET__CE0ye3Sp__"